<template>
  <div class="banner">
    <div>
      <el-carousel height="340px">
        <el-carousel-item v-for="(item, index) in carousel" :key="index">
          <img style="width: 100%; height: 100%" :src="$store.state.baseUrl+item.path" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { indexData } from "@/request/api";
export default {
  data() {
    return {
        carousel: []
    };
  },
  created() {
      this.geyData()
  },
  methods: {
    geyData() {
      indexData().then((res) => {
        if (res.code === 10000) {
          this.carousel = res.data.carousel
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 340px;
  > div {
    width: 1200px;
    margin: 0 auto;
  }
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>


// WEBPACK FOOTER //
// src/components/banner.vue